import { v4 as uuidv4 } from 'uuid';
// Different page size at different places causing the records to be merged and give redundant result for commodities query.
// Page size should be same wherever it is referenced for commodities query in order to maintain caching key during pagination.
// "input" variable is the key in case of commodities query.
export const commodityPageSize = 10;

export const deviceId = uuidv4();
